var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Dialog,{attrs:{"dialog":_setup.dlg}},[_c(_setup.AlertArea,{attrs:{"error":""}},[_vm._v(" Hiermee laat u deze offerte vervallen."),_c('br'),_vm._v(" Wilt u een nieuwe versie van deze offerte maken, gebruik dan de functie 'Maak nieuwe versie'. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }